import { render, staticRenderFns } from "./stationTitleBar.vue?vue&type=template&id=08c863e2&scoped=true&"
import script from "./stationTitleBar.vue?vue&type=script&lang=js&"
export * from "./stationTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./stationTitleBar.vue?vue&type=style&index=0&id=08c863e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c863e2",
  null
  
)

export default component.exports